import { useZaiNativeSideChatModel } from './zai-native-side-chat.model'
import { ZaiNativeSideChatView } from './zai-native-side-chat.view'

import './zai-native-side-chat.styles.scss'

export const ZaiNativeSideChat = () => {
  const model = useZaiNativeSideChatModel()

  return <ZaiNativeSideChatView {...model} />
}
